import type { UseHotkeyOptions } from "@tanstack/react-hotkeys";

export const appShellHotkeyOptions = {
  conflictBehavior: "warn",
  ignoreInputs: true,
  preventDefault: true,
  stopPropagation: true,
} satisfies UseHotkeyOptions;
